var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "card", attrs: { id: "threeDEnvironment" } },
    [
      _c(
        "nav",
        {
          staticClass: "fixed-bar navbar navbar-expand-lg navbar-light",
          attrs: { color: "white" }
        },
        [
          _c("h3", { staticClass: "navbar-brand" }, [
            _vm._v("3D/2.5D Environment")
          ]),
          _vm._v(" "),
          _c("add-environment", {
            attrs: {
              dialog: _vm.dialog,
              info: _vm.editedItem,
              "edited-i-d": _vm.editedID
            },
            on: {
              save: _vm.saveSetDesign,
              open: _vm.openDialog,
              close: _vm.closeDialog
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "container fluid grid-list-lg" },
        [
          _c("asset-table", {
            attrs: {
              updated: _vm.updated,
              asset_type: _vm.asset_type,
              headers: _vm.headers
            },
            on: { edit: _vm.editItem }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8a87db70", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8a87db70","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/assets/environment3D.vue
// module id = null
// module chunks = 